import React from 'react';
// import 'antd/dist/antd.css';
import Icon from '@ant-design/icons';

const UserDashboard = () => (
  <svg
    id="dashboard"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 22.555 22.555">
    <path
      id="Path_6541"
      data-name="Path 6541"
      d="M8.693,7.519H1.645A1.646,1.646,0,0,1,0,5.874V1.645A1.646,1.646,0,0,1,1.645,0H8.693a1.646,1.646,0,0,1,1.645,1.645V5.874A1.646,1.646,0,0,1,8.693,7.519ZM1.645,1.41a.235.235,0,0,0-.235.235V5.874a.235.235,0,0,0,.235.235H8.693a.235.235,0,0,0,.235-.235V1.645a.235.235,0,0,0-.235-.235Zm0,0"
      transform="translate(0 0)"
      fill="currentColor"
    />
    <path
      id="Path_6542"
      data-name="Path 6542"
      d="M8.693,226.489H1.645A1.646,1.646,0,0,1,0,224.845v-9.868a1.646,1.646,0,0,1,1.645-1.645H8.693a1.646,1.646,0,0,1,1.645,1.645v9.868A1.646,1.646,0,0,1,8.693,226.489ZM1.645,214.742a.235.235,0,0,0-.235.235v9.868a.235.235,0,0,0,.235.235H8.693a.235.235,0,0,0,.235-.235v-9.868a.235.235,0,0,0-.235-.235Zm0,0"
      transform="translate(0 -203.934)"
      fill="currentColor"
    />
    <path
      id="Path_6543"
      data-name="Path 6543"
      d="M286.025,348.851h-7.049a1.646,1.646,0,0,1-1.645-1.645v-4.229a1.646,1.646,0,0,1,1.645-1.645h7.049a1.646,1.646,0,0,1,1.645,1.645v4.229A1.646,1.646,0,0,1,286.025,348.851Zm-7.049-6.109a.235.235,0,0,0-.235.235v4.229a.235.235,0,0,0,.235.235h7.049a.235.235,0,0,0,.235-.235v-4.229a.235.235,0,0,0-.235-.235Zm0,0"
      transform="translate(-265.115 -326.295)"
      fill="currentColor"
    />
    <path
      id="Path_6544"
      data-name="Path 6544"
      d="M286.025,13.157h-7.049a1.646,1.646,0,0,1-1.645-1.645V1.645A1.646,1.646,0,0,1,278.977,0h7.049a1.646,1.646,0,0,1,1.645,1.645v9.868A1.646,1.646,0,0,1,286.025,13.157ZM278.977,1.41a.235.235,0,0,0-.235.235v9.868a.235.235,0,0,0,.235.235h7.049a.235.235,0,0,0,.235-.235V1.645a.235.235,0,0,0-.235-.235Zm0,0"
      transform="translate(-265.115 0)"
      fill="currentColor"
    />
  </svg>
);

const AdminDashboard = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-layout-list"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    strokeWidth="2"
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <rect x="4" y="4" width="16" height="6" rx="2" />
    <rect x="4" y="14" width="16" height="6" rx="2" />
  </svg>
);

const ManageCourse = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
    <g id="Messages-icon" transform="translate(-40 -317)">
      <g
        id="Rectangle_23"
        data-name="Rectangle 23"
        transform="translate(46 317)"
        fill="none"
        stroke="currentColor"
        strokeWidth="3">
        <rect width="18" height="10" rx="5" stroke="none" />
        <rect x="1.5" y="1.5" width="15" height="7" rx="3.5" fill="none" />
      </g>
      <g
        id="Rectangle_24"
        data-name="Rectangle 24"
        transform="translate(40 331)"
        fill="none"
        stroke="currentColor"
        strokeWidth="3">
        <rect width="18" height="10" rx="5" stroke="none" />
        <rect x="1.5" y="1.5" width="15" height="7" rx="3.5" fill="none" />
      </g>
    </g>
  </svg>
);

const UserBookmark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16.121 22.223">
    <g id="bookmark-2" transform="translate(-10 -1)">
      <g id="Group_10356" data-name="Group 10356" transform="translate(11 2)">
        <path
          id="Path_6638"
          data-name="Path 6638"
          d="M25.121,21.5l-7.06-4.034L11,21.5V3.345A1.345,1.345,0,0,1,12.345,2H23.776a1.345,1.345,0,0,1,1.345,1.345Z"
          transform="translate(-11 -2)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </g>
    </g>
  </svg>
);

const Courses = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 22.555 22.555">
    <g id="play-button" transform="translate(-0.001 0)">
      <g id="Group_10351" data-name="Group 10351" transform="translate(0.001 0)">
        <g id="Group_10350" data-name="Group 10350" transform="translate(0 0)">
          <path
            id="Path_6635"
            data-name="Path 6635"
            d="M21.041,5.641A11.273,11.273,0,0,0,.39,8.36,11.273,11.273,0,0,0,8.361,22.166a11.334,11.334,0,0,0,2.936.389A11.277,11.277,0,0,0,21.041,5.641Zm-.008,8.25a10.1,10.1,0,0,1-18.5,2.436,10.106,10.106,0,0,1,8.73-15.153,10.155,10.155,0,0,1,2.63.348,10.1,10.1,0,0,1,7.141,12.369Z"
            transform="translate(-0.001 0)"
            fill="currentColor"
          />
        </g>
      </g>
      <g id="Group_10353" data-name="Group 10353" transform="translate(7.597 5.862)">
        <g id="Group_10352" data-name="Group 10352">
          <path
            id="Path_6636"
            data-name="Path 6636"
            d="M181.513,137.433l-7.248-4.185a1.228,1.228,0,0,0-1.843,1.064v8.369a1.226,1.226,0,0,0,1.843,1.064l7.248-4.185a1.229,1.229,0,0,0,0-2.128Zm-.587,1.111-7.248,4.185a.054.054,0,0,1-.082-.047v-8.369a.049.049,0,0,1,.027-.047.055.055,0,0,1,.028-.008.051.051,0,0,1,.027.008l7.248,4.185a.055.055,0,0,1,0,.094Z"
            transform="translate(-172.422 -133.082)"
            fill="currentColor"
          />
        </g>
      </g>
      <g id="Group_10355" data-name="Group 10355" transform="translate(11.784 2.592)">
        <g id="Group_10354" data-name="Group 10354">
          <path
            id="Path_6637"
            data-name="Path 6637"
            d="M273.9,62.184a8.853,8.853,0,0,0-5.758-3.324.587.587,0,0,0-.159,1.163,7.669,7.669,0,0,1,4.988,2.88.587.587,0,0,0,.928-.719Z"
            transform="translate(-267.475 -58.855)"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
);

const Payment = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 21 26">
    <g id="payment-icon" transform="translate(-43.5 -377.5)">
      <g id="Group_4" data-name="Group 4">
        <g id="Group_1" data-name="Group 1" transform="translate(-1180 -511)">
          <path
            id="Subtraction_1"
            data-name="Subtraction 1"
            d="M18,23H0V0H12.279L18,5.158V23Z"
            transform="translate(1225 890)"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
          />
          <text
            id="_"
            data-name="$"
            transform="translate(1229.5 906.381)"
            fill="#fff"
            fontSize="13"
            fontFamily="Roboto-Black, Roboto"
            fontWeight="800">
            <tspan x="0" y="0">
              $
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
);

const Report = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 18">
    <g id="Post-icon" transform="translate(-40 -256)">
      <rect
        id="Rectangle_18"
        data-name="Rectangle 18"
        width="4"
        height="10"
        transform="translate(40 264)"
        fill="currentColor"
      />
      <rect
        id="Rectangle_19"
        data-name="Rectangle 19"
        width="4"
        height="18"
        transform="translate(50 256)"
        fill="currentColor"
      />
      <rect
        id="Rectangle_20"
        data-name="Rectangle 20"
        width="4"
        height="15"
        transform="translate(60 259)"
        fill="currentColor"
      />
    </g>
  </svg>
);

const Settings = () => (
  <svg
    id="settings"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 20.679 20.679">
    <g id="Group_10343" data-name="Group 10343" transform="translate(0 6.893)">
      <g id="Group_10342" data-name="Group 10342">
        <path
          id="Path_6630"
          data-name="Path 6630"
          d="M12.752,165.17h-.379a.339.339,0,0,1-.319-.223c-.042-.11-.087-.218-.136-.325a.34.34,0,0,1,.069-.385l.27-.271a1.036,1.036,0,0,0,0-1.461l-.974-.974a1.036,1.036,0,0,0-1.461,0l-.27.27a.341.341,0,0,1-.385.069c-.107-.049-.215-.094-.325-.138a.339.339,0,0,1-.224-.32v-.379A1.034,1.034,0,0,0,7.582,160H6.2a1.034,1.034,0,0,0-1.034,1.034v.379a.339.339,0,0,1-.223.319c-.11.042-.218.087-.325.136a.341.341,0,0,1-.385-.069l-.271-.27a1.036,1.036,0,0,0-1.461,0l-.974.977a1.036,1.036,0,0,0,0,1.461l.27.27a.34.34,0,0,1,.069.385c-.049.107-.094.215-.136.325a.339.339,0,0,1-.322.222H1.034A1.034,1.034,0,0,0,0,166.2v1.379a1.034,1.034,0,0,0,1.034,1.034h.379a.339.339,0,0,1,.319.223c.042.11.087.218.136.325a.34.34,0,0,1-.069.385l-.27.271a1.036,1.036,0,0,0,0,1.461l.974.974a1.036,1.036,0,0,0,1.461,0l.27-.27a.341.341,0,0,1,.385-.069c.107.049.215.094.325.138a.339.339,0,0,1,.225.32v.379A1.034,1.034,0,0,0,6.2,173.786H7.582a1.034,1.034,0,0,0,1.034-1.034v-.379a.339.339,0,0,1,.223-.319c.11-.042.218-.087.325-.136a.341.341,0,0,1,.385.069l.271.27a1.037,1.037,0,0,0,1.461,0l.974-.974a1.036,1.036,0,0,0,0-1.461l-.27-.27a.34.34,0,0,1-.069-.385c.049-.107.094-.215.138-.325a.339.339,0,0,1,.32-.224h.379a1.034,1.034,0,0,0,1.034-1.034V166.2A1.034,1.034,0,0,0,12.752,165.17Zm.345,2.413a.345.345,0,0,1-.345.345h-.379a1.037,1.037,0,0,0-.965.667q-.055.145-.119.285a1.037,1.037,0,0,0,.207,1.157l.27.27a.345.345,0,0,1,0,.487h0l-.974.974a.345.345,0,0,1-.487,0l-.27-.27a1.036,1.036,0,0,0-1.157-.207c-.093.042-.189.082-.284.119a1.037,1.037,0,0,0-.666.964v.379a.345.345,0,0,1-.345.345H6.2a.345.345,0,0,1-.345-.345v-.379a1.037,1.037,0,0,0-.667-.965q-.145-.055-.285-.119a1.037,1.037,0,0,0-1.157.207l-.27.27a.345.345,0,0,1-.487,0h0l-.974-.973a.345.345,0,0,1,0-.487l.27-.27a1.037,1.037,0,0,0,.207-1.157c-.042-.093-.082-.189-.119-.284a1.037,1.037,0,0,0-.964-.667H1.034a.345.345,0,0,1-.345-.345V166.2a.345.345,0,0,1,.345-.345h.379a1.037,1.037,0,0,0,.965-.667q.055-.145.119-.285a1.037,1.037,0,0,0-.207-1.157l-.271-.27a.345.345,0,0,1,0-.487h0l.974-.974a.345.345,0,0,1,.487,0l.27.27a1.036,1.036,0,0,0,1.157.207c.093-.042.189-.082.284-.119a1.037,1.037,0,0,0,.668-.964v-.379a.345.345,0,0,1,.345-.345H7.582a.345.345,0,0,1,.345.345v.379a1.037,1.037,0,0,0,.667.965q.145.055.285.119a1.036,1.036,0,0,0,1.157-.207l.27-.27a.347.347,0,0,1,.488,0l.974.974a.345.345,0,0,1,0,.487l-.27.27a1.037,1.037,0,0,0-.207,1.157c.042.093.082.189.119.284a1.037,1.037,0,0,0,.964.666h.379a.345.345,0,0,1,.345.345v1.379Z"
          transform="translate(0 -160)"
          fill="currentColor"
        />
      </g>
    </g>
    <g id="Group_10345" data-name="Group 10345" transform="translate(3.789 10.684)">
      <g id="Group_10344" data-name="Group 10344">
        <path
          id="Path_6631"
          data-name="Path 6631"
          d="M94.157,250.964c0-.083-.009-.165-.019-.247s-.024-.176-.042-.262c-.012-.056-.028-.112-.043-.168q-.029-.106-.065-.21c-.017-.048-.034-.1-.052-.143a3.072,3.072,0,0,0-.152-.323c0-.008-.007-.017-.012-.024a3.056,3.056,0,0,0-.31-.452c-.01-.012-.021-.024-.032-.036-.048-.056-.1-.111-.148-.163-.027-.028-.055-.054-.083-.081s-.069-.064-.1-.094-.084-.071-.128-.105l-.057-.042A3.08,3.08,0,0,0,91.062,248c-.034,0-.069.005-.1.007-.073,0-.147.006-.221.014l-.117.014a3.164,3.164,0,0,0-.334.062,3.1,3.1,0,0,0,0,6.01l.017,0a3.293,3.293,0,0,0,.361.069c.08.01.161.012.241.016.054,0,.1.011.16.011.1,0,.2-.007.3-.017a.34.34,0,0,0,.034,0c.084-.009.169-.022.255-.039.034-.007.067-.015.1-.023.061-.014.121-.029.183-.047s.1-.031.142-.048l.145-.053c.049-.019.09-.04.134-.061s.115-.053.172-.084h0a4.079,4.079,0,0,0,.883-.638,1.085,1.085,0,0,0,.185-.226,3.679,3.679,0,0,0,.519-1.417c.01-.066.018-.133.023-.2s.008-.124.01-.186c0-.02,0-.038,0-.058C94.164,251.056,94.159,251.011,94.157,250.964Zm-.687.226c0,.029,0,.057,0,.086-.006.083-.017.167-.031.251a2.418,2.418,0,0,1-1.211,1.689c-.043.022-.085.043-.127.063l-.029.014a2.489,2.489,0,0,1-.629.19l-.046.007c-.043.006-.085.011-.128.015s-.111.008-.168.009h-.072a2.424,2.424,0,0,1-.244-.015l-.041,0a2.556,2.556,0,0,1-.282-.053,2.413,2.413,0,0,1,0-4.674h0a2.5,2.5,0,0,1,.606-.076,2.379,2.379,0,0,1,.295.02l.078.012c.074.012.148.027.221.045l.071.018a2.433,2.433,0,0,1,.526.221l.079.048c.054.034.107.069.159.108.028.02.056.04.083.062a2.487,2.487,0,0,1,.194.172c.024.025.047.052.071.078.04.043.078.087.115.134s.05.065.074.1c.034.05.069.1.1.154l.052.086a2.361,2.361,0,0,1,.119.253c.014.034.025.069.038.1.022.063.042.128.059.192.009.034.018.065.026.1a2.432,2.432,0,0,1,.044.282c0,.025,0,.051,0,.076C93.472,251.03,93.473,251.11,93.47,251.19Z"
          transform="translate(-87.959 -248)"
          fill="#fcfcfc"
        />
      </g>
    </g>
    <g id="Group_10347" data-name="Group 10347" transform="translate(3.759)">
      <g id="Group_10346" data-name="Group 10346">
        <path
          id="Path_6632"
          data-name="Path 6632"
          d="M103.147,7.238h-1.084a.336.336,0,0,1-.321-.226,7.18,7.18,0,0,0-.387-.934.337.337,0,0,1,.066-.389l.769-.77a1.034,1.034,0,0,0,0-1.462l-1.465-1.463a1.034,1.034,0,0,0-1.462,0l-.768.768a.337.337,0,0,1-.389.067,7.16,7.16,0,0,0-.935-.389.336.336,0,0,1-.227-.321V1.034A1.034,1.034,0,0,0,95.909,0H93.841a1.034,1.034,0,0,0-1.034,1.034V2.118a.336.336,0,0,1-.226.321,7.183,7.183,0,0,0-.934.389.337.337,0,0,1-.389-.066l-.77-.769a1.036,1.036,0,0,0-1.462,0L87.564,3.456a1.034,1.034,0,0,0,0,1.462l1.13,1.132a.345.345,0,0,0,.488-.487L88.051,4.431a.345.345,0,0,1,0-.487l1.463-1.463a.345.345,0,0,1,.487,0l.77.769a1.025,1.025,0,0,0,1.184.194,6.521,6.521,0,0,1,.845-.351,1.025,1.025,0,0,0,.7-.975V1.034a.345.345,0,0,1,.345-.345h2.068a.345.345,0,0,1,.345.345V2.118a1.025,1.025,0,0,0,.7.975,6.5,6.5,0,0,1,.845.352,1.027,1.027,0,0,0,1.184-.195l.77-.768a.345.345,0,0,1,.487,0L101.7,3.944a.345.345,0,0,1,0,.487l-.769.77a1.026,1.026,0,0,0-.194,1.184,6.519,6.519,0,0,1,.351.845,1.025,1.025,0,0,0,.975.7h1.084a.345.345,0,0,1,.345.345v2.068a.345.345,0,0,1-.345.345h-1.084a1.025,1.025,0,0,0-.975.7,6.493,6.493,0,0,1-.352.845,1.026,1.026,0,0,0,.195,1.184l.769.77a.345.345,0,0,1,0,.487l-1.463,1.463a.345.345,0,0,1-.487,0L98.617,15a.345.345,0,1,0-.5.48l.008.008,1.132,1.13a1.034,1.034,0,0,0,1.462,0l1.463-1.462a1.034,1.034,0,0,0,0-1.462l-.768-.769a.338.338,0,0,1-.067-.389,7.163,7.163,0,0,0,.389-.935.336.336,0,0,1,.321-.227h1.084a1.034,1.034,0,0,0,1.034-1.034V8.272A1.034,1.034,0,0,0,103.147,7.238Z"
          transform="translate(-87.261)"
          fill="#fcfcfc"
        />
      </g>
    </g>
    <g id="Group_10349" data-name="Group 10349" transform="translate(8.109 4.827)">
      <g id="Group_10348" data-name="Group 10348">
        <path
          id="Path_6633"
          data-name="Path 6633"
          d="M194.651,113.36a4.485,4.485,0,0,0-6.336,0,.345.345,0,0,0,.487.487,3.791,3.791,0,1,1,5.4,5.325l-.036.036a.345.345,0,1,0,.479.5l.008-.008A4.485,4.485,0,0,0,194.651,113.36Z"
          transform="translate(-188.219 -112.049)"
          fill="#fcfcfc"
        />
      </g>
    </g>
  </svg>
);
const FacebookI = () => (
  <svg width="38" height="38" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25.8789" cy="25.121" r="24.2548" stroke="#0966B8" stroke-width="1.73249" />
    <path
      d="M27.097 36.6591V25.5298H30.8515L31.4096 21.1723H27.097V18.3968C27.097 17.1394 27.4473 16.2785 29.2519 16.2785H31.5386V12.3935C30.426 12.2743 29.3077 12.2167 28.1887 12.2211C24.87 12.2211 22.5915 14.247 22.5915 17.9663V21.1642H18.8613V25.5216H22.5996V36.6591H27.097Z"
      fill="#0966B8"
    />
  </svg>
);
const LinkedI = () => (
  <svg width="38" height="38" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25.1211" cy="25.1211" r="24.2548" stroke="#0966B8" stroke-width="1.73249" />
    <path
      d="M27.158 33.9476H21.7265V17.6528H27.158V20.3686C27.7299 19.6412 28.4556 19.0492 29.2831 18.6354C30.1107 18.2215 31.0196 17.9958 31.9446 17.9747C33.5624 17.9836 35.1106 18.6338 36.2497 19.7826C37.3888 20.9314 38.0259 22.485 38.0212 24.1028V33.9476H32.5896V24.7818C32.4846 24.0479 32.118 23.3767 31.5574 22.8917C30.9967 22.4067 30.2798 22.1404 29.5384 22.142C29.2066 22.1525 28.8804 22.2299 28.5793 22.3696C28.2781 22.5093 28.0083 22.7084 27.786 22.9549C27.5637 23.2014 27.3935 23.4903 27.2856 23.8042C27.1777 24.1182 27.1343 24.4507 27.158 24.7818V33.9476ZM19.0107 33.9476H13.5791V17.6528H19.0107V33.9476ZM16.2949 14.937C15.5746 14.937 14.8838 14.6509 14.3745 14.1416C13.8652 13.6323 13.5791 12.9415 13.5791 12.2213C13.5791 11.501 13.8652 10.8102 14.3745 10.3009C14.8838 9.79159 15.5746 9.50546 16.2949 9.50546C17.0152 9.50546 17.7059 9.79159 18.2152 10.3009C18.7246 10.8102 19.0107 11.501 19.0107 12.2213C19.0107 12.9415 18.7246 13.6323 18.2152 14.1416C17.7059 14.6509 17.0152 14.937 16.2949 14.937Z"
      fill="#0966B8"
    />
  </svg>
);
const GramI = () => (
  <svg width="38" height="38" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25.374" cy="25.121" r="24.2548" stroke="#0966B8" stroke-width="1.73249" />
    <path
      d="M24.693 18.1644C23.0277 18.1644 21.4306 18.8259 20.2531 20.0035C19.0756 21.181 18.4141 22.7781 18.4141 24.4433C18.4141 26.1086 19.0756 27.7057 20.2531 28.8832C21.4306 30.0607 23.0277 30.7222 24.693 30.7222C26.3582 30.7222 27.9553 30.0607 29.1328 28.8832C30.3103 27.7057 30.9719 26.1086 30.9719 24.4433C30.9719 22.7781 30.3103 21.181 29.1328 20.0035C27.9553 18.8259 26.3582 18.1644 24.693 18.1644V18.1644ZM24.693 28.5211C23.6111 28.5211 22.5736 28.0913 21.8086 27.3263C21.0436 26.5614 20.6139 25.5238 20.6139 24.442C20.6139 23.3601 21.0436 22.3226 21.8086 21.5576C22.5736 20.7926 23.6111 20.3629 24.693 20.3629C25.7748 20.3629 26.8124 20.7926 27.5773 21.5576C28.3423 22.3226 28.7721 23.3601 28.7721 24.442C28.7721 25.5238 28.3423 26.5614 27.5773 27.3263C26.8124 28.0913 25.7748 28.5211 24.693 28.5211V28.5211Z"
      fill="#0966B8"
    />
    <path
      d="M31.2206 19.3972C32.0291 19.3972 32.6845 18.7418 32.6845 17.9334C32.6845 17.1249 32.0291 16.4696 31.2206 16.4696C30.4122 16.4696 29.7568 17.1249 29.7568 17.9334C29.7568 18.7418 30.4122 19.3972 31.2206 19.3972Z"
      fill="#0966B8"
    />
    <path
      d="M36.2818 16.4451C35.9675 15.6333 35.4871 14.8961 34.8714 14.2807C34.2558 13.6653 33.5184 13.1852 32.7065 12.8711C31.7564 12.5145 30.7527 12.3217 29.7381 12.3008C28.4305 12.2438 28.0163 12.2275 24.7003 12.2275C21.3844 12.2275 20.9593 12.2275 19.6625 12.3008C18.6487 12.3206 17.6457 12.5135 16.6969 12.8711C15.8848 13.1848 15.1472 13.6648 14.5315 14.2803C13.9158 14.8957 13.4355 15.6331 13.1216 16.4451C12.7648 17.3951 12.5724 18.3989 12.5526 19.4135C12.4942 20.7198 12.4766 21.1339 12.4766 24.4513C12.4766 27.7672 12.4766 28.1896 12.5526 29.4891C12.573 30.5048 12.7644 31.5069 13.1216 32.4588C13.4364 33.2705 13.9171 34.0076 14.533 34.623C15.1489 35.2383 15.8863 35.7185 16.6983 36.0328C17.6453 36.4037 18.6487 36.6104 19.6653 36.6438C20.9729 36.7008 21.3871 36.7185 24.703 36.7185C28.019 36.7185 28.444 36.7185 29.7408 36.6438C30.7553 36.6232 31.759 36.4308 32.7092 36.0749C33.5209 35.7601 34.258 35.2796 34.8736 34.664C35.4892 34.0484 35.9698 33.3112 36.2845 32.4995C36.6417 31.549 36.8331 30.5469 36.8535 29.5312C36.9119 28.2249 36.9295 27.8107 36.9295 24.4934C36.9295 21.176 36.9295 20.7551 36.8535 19.4556C36.8377 18.4267 36.6443 17.4082 36.2818 16.4451V16.4451ZM34.6279 29.3886C34.6191 30.1711 34.4763 30.9464 34.2056 31.6807C34.0017 32.2087 33.6895 32.6883 33.2891 33.0884C32.8887 33.4885 32.409 33.8004 31.8809 34.0041C31.1547 34.2735 30.3877 34.4164 29.6132 34.4264C28.3232 34.4861 27.9593 34.5011 24.6514 34.5011C21.3409 34.5011 21.0028 34.5011 19.6883 34.4264C18.9142 34.4169 18.1476 34.274 17.422 34.0041C16.892 33.8017 16.4104 33.4904 16.0083 33.0901C15.6062 32.6899 15.2926 32.2098 15.0878 31.6807C14.8209 30.9543 14.6781 30.1882 14.6655 29.4144C14.6071 28.1244 14.5935 27.7605 14.5935 24.4526C14.5935 21.1434 14.5935 20.8053 14.6655 19.4895C14.6743 18.7074 14.8171 17.9326 15.0878 17.1988C15.502 16.1274 16.3506 15.2841 17.422 14.874C18.1479 14.6054 18.9144 14.4625 19.6883 14.4517C20.9797 14.3933 21.3423 14.377 24.6514 14.377C27.9606 14.377 28.3001 14.377 29.6132 14.4517C30.3877 14.4611 31.1549 14.6039 31.8809 14.874C32.409 15.0781 32.8886 15.3903 33.289 15.7907C33.6893 16.191 34.0015 16.6706 34.2056 17.1988C34.4725 17.9252 34.6153 18.6913 34.6279 19.4651C34.6863 20.7564 34.7012 21.119 34.7012 24.4282C34.7012 27.736 34.7012 28.0918 34.6428 29.3899H34.6279V29.3886Z"
      fill="#0966B8"
    />
  </svg>
);
const TwitterI = () => (
  <svg width="38" height="38" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25.6259" cy="25.121" r="24.2548" stroke="#0966B8" stroke-width="1.73249" />
    <path
      d="M35.3119 19.0065C35.3296 19.2441 35.3296 19.4804 35.3296 19.7167C35.3296 26.9475 29.826 35.2795 19.7681 35.2795C16.6694 35.2795 13.7906 34.3819 11.3682 32.8231C11.8081 32.8733 12.2318 32.891 12.6894 32.891C15.1512 32.8969 17.5434 32.0737 19.4802 30.554C18.3388 30.5334 17.2323 30.1568 16.3153 29.4769C15.3983 28.7969 14.7164 27.8476 14.365 26.7614C14.7032 26.8117 15.0426 26.8456 15.3984 26.8456C15.8886 26.8456 16.3815 26.7777 16.8391 26.6596C15.6004 26.4095 14.4865 25.7381 13.6869 24.7595C12.8873 23.7809 12.4513 22.5556 12.4531 21.2918V21.2239C13.1823 21.63 14.0283 21.8839 14.9245 21.9178C14.1737 21.4189 13.5581 20.7419 13.1325 19.9472C12.707 19.1526 12.4848 18.2649 12.4857 17.3635C12.4857 16.3477 12.7559 15.4162 13.2298 14.6042C14.6042 16.2948 16.3184 17.6779 18.2613 18.6638C20.2042 19.6498 22.3326 20.2167 24.5085 20.3277C24.4243 19.9204 24.3727 19.4981 24.3727 19.0744C24.3724 18.356 24.5136 17.6446 24.7883 16.9808C25.0631 16.3171 25.466 15.714 25.9739 15.206C26.4819 14.698 27.085 14.2952 27.7488 14.0204C28.4125 13.7457 29.1239 13.6044 29.8423 13.6048C31.4175 13.6048 32.8392 14.2647 33.8386 15.332C35.0631 15.0952 36.2374 14.6482 37.3094 14.0108C36.9012 15.2748 36.0462 16.3465 34.9046 17.0253C35.9906 16.9015 37.052 16.6159 38.0535 16.178C37.3055 17.2685 36.3786 18.2248 35.3119 19.0065Z"
      fill="#0966B8"
    />
  </svg>
);

export const BookmarkIcon = props => <Icon component={UserBookmark} {...props} />;
export const ManageCourseIcon = props => <Icon component={ManageCourse} {...props} />;
export const UserDashboardIcon = props => <Icon component={UserDashboard} {...props} />;
export const AdminDashboardIcon = props => <Icon component={AdminDashboard} {...props} />;
export const CourseIcon = props => <Icon component={Courses} {...props} />;
export const ReportIcon = props => <Icon component={Report} {...props} />;
export const SettingsIcon = props => <Icon component={Settings} {...props} />;
export const PaymentIcon = props => <Icon component={Payment} {...props} />;
export const IconFacebook = props => <Icon component={FacebookI} {...props} />;
export const IconLinked = props => <Icon component={LinkedI} {...props} />;
export const IconGram = props => <Icon component={GramI} {...props} />;
export const IconTwitter = props => <Icon component={TwitterI} {...props} />;
